import React from 'react';
import { useSelector } from 'react-redux';

import { selectTaxProfileState } from '../selectors/tax.selector';
import { selectWinnings } from '../selectors/prize.selector';
import { selectAccountInfo } from '../selectors/account.selector';
import { findFirstPrizeWithTaxInterviewUrl, isUserUnder18 } from '../utils/prizeAgeUtils';

interface UseStep1InterviewReturn {
    showGate: boolean;
    isUnder18: boolean;
    retakeWithFirstPrize: boolean;
}

export const useFirstPrizeWithInterviewUrl = (): UseStep1InterviewReturn => {
    const winnings = useSelector(selectWinnings);
    const taxProfileState = useSelector(selectTaxProfileState);
    const accountInfo = useSelector(selectAccountInfo);

    const firstPrizeWithTaxInterviewUrl = findFirstPrizeWithTaxInterviewUrl(winnings, accountInfo);
    const isUnder18 = isUserUnder18(accountInfo);

    const showGate = Boolean(
        firstPrizeWithTaxInterviewUrl && !taxProfileState?.retakeAvailable && !isUnder18 // go interview page directly when user account < 18
    );
    const retakeWithFirstPrize = Boolean(
        firstPrizeWithTaxInterviewUrl && !taxProfileState?.retakeAvailable
    );

    return React.useMemo(() => {
        return { showGate, isUnder18, retakeWithFirstPrize };
    }, [showGate, isUnder18, retakeWithFirstPrize]);
};
